<template>
    <CommonList
            selection-type="checkbox"
            row-key="id"
            :has-more-search="false"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            @selection-change="handleSelectionChange"
            @current-row-change="handleCurrentRowChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <!-- 固定搜索区 -->
        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">枚举标识：</label>
                <el-input v-model="searchForm.enumType" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">枚举描述：</label>
                <el-input v-model="searchForm.enumName" class="common-input120" placeholder="请输入"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">生效：</label>
                <el-select v-model="searchForm.isDeleted" class="common-input100" placeholder="请选择">
                    <el-option label="是" value="0"></el-option>
                    <el-option label="否" value="1"></el-option>
                </el-select>
            </div>
        </template>

        <!-- 操作按钮 -->
        <template #btn-group>
            <el-button type="primary" class="list-btn" @click="handleAdd">
                <el-icon>
                    <Plus/>
                </el-icon>
                新增枚举
            </el-button>
            <el-button
                    type="warning"
                    class="list-btn"
                    @click="handleEdit"
                    :disabled="!editShow"
            >
                <el-icon>
                    <Edit/>
                </el-icon>
                修改枚举
            </el-button>
            <el-button
                    type="danger"
                    class="list-btn"
                    @click="handleDelete"
                    :disabled="!delShow"
            >
                <el-icon>
                    <Delete/>
                </el-icon>
                删除枚举
            </el-button>
        </template>

        <!-- 表格列 width="auto" 占剩余宽度 :resizable="false" 不可拖拽-->
        <template #table-column>
            <el-table-column prop="enumType" label="枚举标识" align="center" width="120"></el-table-column>
            <el-table-column prop="enumName" label="枚举描述" align="center" width="180"></el-table-column>
            <el-table-column prop="enumCode" label="子枚举标识" align="center" width="120"></el-table-column>
            <el-table-column prop="enumCodeName" label="子描述" align="center" min-width="180"></el-table-column>
            <el-table-column prop="code" label="码值" align="center" min-width="120"></el-table-column>
            <el-table-column prop="isDeleted" label="是否生效" align="center" width="100" >
                <template #default="scope">
                    <el-tag :class="scope.row.isDeleted === 0 ? 'list-status-normal' : 'list-status-deleted'">
                        {{ scope.row.isDeleted === 0? '是' : '否' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="groupCode" label="分组编码" align="center" min-width="180"></el-table-column>
            <el-table-column prop="groupName" label="分组描述" align="auto" min-width="180" :resizable="false"></el-table-column>
        </template>

        <!-- 新增/编辑弹窗 -->
        <template #extra>
            <el-dialog
                    v-model="dialogVisible"
                    :title="dialogType === 'add' ? '新增枚举' : '修改枚举'"
                    width="900px"
                    destroy-on-close
            >
                <el-form
                        ref="formRef"
                        :model="formData"
                        :rules="formRules"
                        label-width="100px"
                        class="list-modal-form"
                >
                    <el-form-item label="枚举标识" prop="enumType">
                        <el-input
                                v-model="formData.enumType"
                                :disabled="dialogType === 'edit'"
                                placeholder="请输入枚举"
                                maxlength="50"
                                style="width: 150px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="枚举描述" prop="enumName">
                        <el-input
                                v-model="formData.enumName"
                                placeholder="请输入枚举描述"
                                maxlength="100"
                                style="width: 200px"
                        ></el-input>
                    </el-form-item>

                    <!-- 用 el-table 实现动态行（Element Plus 原生） -->
                    <el-form-item label="" label-width="0px"  class="no-label-form-item" prop="dynamicRows">
                        <el-table
                                :data="formData.dynamicRows"
                                border
                                style="width: 100%; margin-top: 10px;"
                        >
                            <!-- 枚举值列 -->
                            <el-table-column label="子枚举标识" width="150px" align="center">
                                <template #default="scope">
                                    <el-form-item>
                                        <el-input v-model="scope.row.enumCode" placeholder="子枚举标识"  maxlength="50"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 值描述列 -->
                            <el-table-column label="子描述" width="150px" align="center">
                                <template #default="scope">
                                    <el-form-item>
                                        <el-input v-model="scope.row.enumCodeName" placeholder="子描述"  maxlength="100"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>

                            <el-table-column label="码值" width="150px" align="center">
                                <template #default="scope">
                                    <el-form-item>
                                        <el-input v-model="scope.row.code" placeholder="码值"  maxlength="50"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 分组编码列 -->
                            <el-table-column label="分组编码(可不填)" width="150px" align="center">
                                <template #default="scope">
                                    <el-form-item>
                                        <el-input v-model="scope.row.groupCode" placeholder="1,2,3" maxlength="50"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 分组描述列 -->
                            <el-table-column label="分组描述(可不填)" width="150px" align="center">
                                <template #default="scope">
                                    <el-form-item>
                                        <el-input v-model="scope.row.groupName" placeholder="分组1,分组2，分组3"  maxlength="100"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 是否生效列 -->
                            <el-table-column label="是否生效" width="150px" align="center">
                                <template #default="scope">
                                    <el-form-item>
                                        <el-radio-group v-model="scope.row.isDeleted">
                                            <el-radio :label="0">是</el-radio>
                                            <el-radio :label="1">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <!-- 操作列 -->
                            <el-table-column label="操作" width="auto" align="center" >
                                <template #default="scope">
                                    <el-button
                                            type="danger"
                                            size="small"
                                            icon="el-icon-delete"
                                            @click="removeDynamicRow(scope.$index)"
                                            v-if="!scope.row.id"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <!-- 添加行按钮（Element Plus 原生按钮） -->
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="addDynamicRow" style="margin-top: 10px;">
                            添加枚举值
                        </el-button>
                    </el-form-item>
                </el-form>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">确定</el-button>
                    </div>
                </template>
            </el-dialog>
        </template>
    </CommonList>
</template>

<script setup>
    import useRoleList from './enumList.js';
    import { ref } from 'vue';

    // 暴露树组件供js使用 判断树组件渲染完成后再 初始化 check
    const roleTreeRef = ref(null);

    const {
        // 响应式数据
        searchForm,
        listRef,
        dialogType,
        formRef,
        editShow,
        delShow,
        formData,
        formRules,
        // 图标
        Plus, Edit, Delete,
        // 列表交互方法
        handleSelectionChange,
        handleCurrentRowChange,
        // 列表操作方法
        handleAdd,
        handleEdit,
        handleDelete,
        handleSubmit,
        handleLoadList,
        handleReset,
        // 动态行操作方法
        addDynamicRow,
        removeDynamicRow,
        // 弹窗状态
        dialogVisible
    } = useRoleList(roleTreeRef);
</script>

<style>
    @import '../../../assets/css/util/base-list.css';
</style>
<style scoped>
    /* 菜单树样式优化 - 注：当前组件未使用菜单树，该样式可评估删除 */
    .menu-tree {
        max-height: 400px;
        overflow-y: auto;
        padding: 10px;
    }
</style>